import React, { useState,useEffect } from "react";

import {
  Typography,
  Radio,
  Space,
  Divider,
  Descriptions,
  Card,
  Row,
  Col,
  Button,
  Steps,
  message,
} from "antd";
import OrderService from "../../services/OrderService";
import "./style.scss"
import CateringItems from "./CateringItems";
import CateringOrderDetail from "./CateringOrderDetail";
import Spinner from "../../components/Layout/Spinner";
import moment from "moment"
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';


const { Title } = Typography;

const Circle = () => {
  return (
    <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 30.1807C23.2843 30.1807 30 23.4245 30 15.0904C30 6.75618 23.2843 0 15 0C6.71573 0 0 6.75618 0 15.0904C0 23.4245 6.71573 30.1807 15 30.1807ZM14.9998 22.2375C18.9239 22.2375 22.1051 19.0372 22.1051 15.0895C22.1051 11.1417 18.9239 7.94141 14.9998 7.94141C11.0757 7.94141 7.89453 11.1417 7.89453 15.0895C7.89453 19.0372 11.0757 22.2375 14.9998 22.2375Z"
      fill="#3A3A3A"
      fill-opacity="0.7"
    />
    </svg>
  )
}

export default function Orders() {
  const [size, setSize] = useState("All");
  const [orders, setOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleItem, setSingleItem] = useState();

  useEffect(() => {
    getOrders();
  }, [size]);

  const getOrders = async () => {
    setLoading(true)
    const data = await OrderService.getCateringRequest(size);
    setOrders(data?.catering_requests || []);
    setLoading(false)
  }; 
  const approve = async (item,event,type) => {
    event.stopPropagation()
    setLoading(true)
    const approveitem = await OrderService.cateringRequestApprove(item.id,type);
    if(approveitem?.err)
    {

      message.error(approveitem?.msg)
    }
    else{
    const data = await OrderService.getCateringRequest(size);
    setOrders(data?.catering_requests || []);
    }
    setLoading(false)
  }; 
 

  const showDetailsView=(value)=>{
    setShowDetails(value)
  }

  const getSingleRequests = async(event,item)=>{
    event.stopPropagation()
    setSelectedOrders(item)
    const data = await OrderService.SingleCateringRequest(item?.id);
    setSingleItem(data)
    setAddModal(true)
  }
  const getSingleRequestsDetails = async(item)=>{
   
    const data = await OrderService.SingleCateringRequest(item?.id);
    setSingleItem(data)
    setSelectedOrders(item)
    setShowDetails(true)
  }
  return (  
    <div className="calander">
      {showDetails?
      <CateringOrderDetail order={singleItem} setShowDetails ={showDetailsView}/>:
      <div>
      <div className="catering-header">
        <Title level={4}>Catering</Title>
      </div>
      <div style={{ textAlign: "left" }}>
        <Radio.Group
          size="large"
          value={size}
          onChange={(e) => setSize(e.target.value)}
        >
          <Radio.Button value="All">All Request</Radio.Button>
          <Radio.Button className="accepted-tab" value="ACCEPTED">Accepted Orders</Radio.Button>
          <Radio.Button value="READY">Completed Orders</Radio.Button>
          <Radio.Button value="FULFILLED">Delivered Orders</Radio.Button>
          <Radio.Button className="rejected-tab" value="REJECTED">Rejected Orders</Radio.Button>
        </Radio.Group>
      </div>
      {orders.map(item=>
      <div style={{ marginTop: 40 }}>
        <Card bordered={false} className="card-order-container" onClick={()=>{
          getSingleRequestsDetails(item)
        
        }}>
          <Row gutter={[16,16]}>
            <Col xs={24} lg={8}>
              <Row className="border-dash-start-top">
                <Col span={24}>
                  <Descriptions column={1}>
                    <Descriptions.Item label={item?.order? "Order ID" : "Request ID"}>
                      <span style={{ color: "#C32340", fontWeight: 600,cursor:"pointer" }}>
                        {item?.order? item?.order?.id : item.id}
                      </span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Branch">
                   {item.restaurant?.name}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
              <Row className="border-dash-start-bottom">
                <Col span={24}>
                  <Descriptions column={1}>
                    <Descriptions.Item label="Name">
                      {item?.customer?.name}
                    </Descriptions.Item>
                    <Descriptions.Item label="Email">
                    {item?.customer?.email}
                    </Descriptions.Item>
                    <Descriptions.Item label="Phone">
                    {item?.customer?.phone_number}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={12} className="border-dash-middle">
              <Descriptions column={1}>
                <Descriptions.Item label="Event type" className="view-item-parent-div">
                  <div>
                  {item.event_type}
                  </div>
                  <Button type="text" danger onClick={(event)=>{
                    getSingleRequests(event,item)
                   }}>View Items</Button>
                </Descriptions.Item>
                <Descriptions.Item label="Event date">
                {moment(item.event_time).format("MM/DD/yyyy")}
                </Descriptions.Item>
                <Descriptions.Item label="Event time">
                 
                  {moment(item.event_time).format("h:mm:ss a")}
                </Descriptions.Item>
                <Descriptions.Item label="Event Location">
                  {item?.customer_location?.address_field1+","+item?.customer_location?.address_field2+","+item?.customer_location?.city}
                </Descriptions.Item>
                <Descriptions.Item label="Order Total">
                  1425.99
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col xs={24} lg={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {item.status == "READY"?<>
                <CheckOutlined style={{color:"green",fontSize:"20px"}}/>
                <Button
                  type="text"
                  style={{
                   
                    display: "block",
                    width: 180,
                   color:"green",
                    marginTop: 5,
                  }}
                  
                >
                  Order Completed
                </Button>
                <Button
                  type="primary"
                  ghost
                  style={{
                    display: "block",
                    width: 180,
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"FULFILL")}
                >
                  Mark as Delivered
                </Button>
                </>
                :
                item.status == "FULFILLED"?
                <>
                <CheckOutlined style={{color:"green",fontSize:"20px"}}/>
                <Button
                  type="text"
                  style={{
                   
                    display: "block",
                    width: 180,
                   color:"green",
                    marginTop: 5,
                  }}
                  
                >
                  Order Delivered
                </Button>
                </>:
                item.status == "PREPARING"?
                <>
                <Button
                  type="primary"
                  ghost
                  style={{
                    display: "block",
                    width: 180,
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"COMPLETE")}
                >
                  Complete Order
                </Button></>:
                item.status == "ACCEPTED"?
                <>
                 <Button
                  type="primary"
                  style={{
                    backgroundColor: "#C32340",
                    display: "block",
                    width: 180,
                    borderColor: "#C32340",
                    color:"#fff",
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"PREPARE")}
                >
                  Start Preparing
                </Button>
                <Button
                  type="primary"
                  ghost
                  style={{
                    display: "block",
                    width: 180,
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"COMPLETE")}
                >
                  Complete Order
                </Button>
                </>:
                item.status == "REJECTED"?
                <>
                <CloseOutlined style={{color:"red",fontSize:"20px"}}/>
                <Button
                  type="text"
                  style={{
                   
                    display: "block",
                    width: 180,
                   color:"red",
                    marginTop: 5,
                  }}
                  
                >
                  Order Rejected
                </Button></>:
                <>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#23C376",
                    display: "block",
                    width: 180,
                    borderColor: "#23C376",
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"APPROVE")}
                >
                  Accept
                </Button>
                <Button
                  type="primary"
                  ghost
                  style={{
                    display: "block",
                    width: 180,
                    marginTop: 20,
                  }}
                  onClick={(e)=>approve(item,e,"REJECT")}
                >
                  Reject
                </Button>
                </>}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24} className="border-dash-stepper">
              <Steps
                labelPlacement="vertical"
                current={(item.status == "FULFILLED") ? 2 :
                item.status == "READY" ? 1: item.status =="ORDER_PLACED"?-1 :0}
                items={[
                  {
                    title: "Accepted",
                    icon: <Circle />,
                  },
                  {
                    title: "Completed",
                    icon: <Circle />,
                  },
                  {
                    title: "Delivered",
                    icon: <Circle />,
                  },
                ]}
              />
            </Col>
          </Row>
        </Card>
      </div>
)}
{loading && <Spinner/>}
      {addModal &&
                <CateringItems modalOpen={true} cateringItems ={singleItem} closeModal={setAddModal} 
                 />}
                 </div>}
    </div>
  );
}
